import React from "react";
import { Icon } from "@chakra-ui/react";

export const ArrowRightIcon = ({ ...props }) => {
  return (
    <Icon as="svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.99984 6L8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L15.9998 12L9.99984 6Z"
        fill="currentColor"
      />
    </Icon>
  );
};
